import { formatDateWords, todayInTenant } from './tenantClock';

// The fields the Quote Price Reminder (Sales Settings › Quotes) can carry,
// each typed as {key} and filled in on the Quote, screen and print.
export const QUOTE_REMINDER_FIELDS = [
  { key: 'valid_until', label: 'Valid Until date, e.g. 14 Nov 2026' },
];

// A Quote's Valid Until: its own once Sent, else the date it would get if
// Sent today (today + Quotes Valid For days).
export function quoteValidUntil(quote, validDays) {
  if (quote?.status && quote.status !== 'draft' && quote.valid_until) return quote.valid_until;
  const n = Number(validDays);
  if (!(n > 0)) return null;
  const d = new Date(`${todayInTenant()}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + n);
  return d.toISOString().slice(0, 10);
}

// The reminder with each {field} filled in. A field with no value shows blank.
export function fillQuoteReminder(text, { validUntil } = {}) {
  if (!text) return '';
  return text.replace(/\{valid_until\}/g, formatDateWords(validUntil));
}

// The Shipping Service's disclaimer (footnote 1) with the Estimate Shipping
// wording run on after it, so a Quote carrying both shows one footnote
// rather than a 1 and a *. Adds the full stop the disclaimer may lack.
export function joinShippingNotes(disclaimer, estimateWording) {
  const first = disclaimer.trim();
  return `${first}${/[.!?]$/.test(first) ? '' : '.'} ${estimateWording}`;
}
